/**
 * Common Parsers
 * Parsers for common API responses
 */

/**
 * Parse version check API response
 * @param {Object} response - API response
 * @returns {Object} Parsed version check data
 */
export const parseVersionCheckResponse = (response) => {
  if (!response || !response.data) {
    return {
      updateRequired: false,
      updateType: 'none',
      latestVersion: null,
      minSupportedVersion: null,
      updateUrl: null,
      releaseNotes: null,
      releaseDate: null
    };
  }

  return {
    updateRequired: response.data.updateRequired || false,
    updateType: response.data.updateType || 'none', // 'force', 'partial', or 'none'
    latestVersion: response.data.latestVersion,
    minSupportedVersion: response.data.minSupportedVersion,
    updateUrl: response.data.updateUrl || {},
    releaseNotes: response.data.releaseNotes || '',
    releaseDate: response.data.releaseDate || null,
    criticalUpdate: response.data.criticalUpdate || false,
    changelog: response.data.changelog || []
  };
};

/**
 * Parse app config API response
 * @param {Object} response - API response
 * @returns {Object} Parsed app config
 */
export const parseAppConfigResponse = (response) => {
  if (!response || !response.data) {
    return {
      appName: 'Inxits Customer',
      environment: 'production',
      features: {},
      settings: {}
    };
  }

  return {
    appName: response.data.appName || 'Inxits Customer',
    environment: response.data.environment || 'production',
    features: response.data.features || {},
    settings: response.data.settings || {},
    apiVersion: response.data.apiVersion || '1.0.0'
  };
};
